import React, {useEffect, useRef, useState} from 'react';
import {connect} from 'react-redux';
import {debounce} from 'lodash';
import 'leaflet/dist/leaflet.css';
import './styles.css';
import L, {Icon} from 'leaflet'

import TopBar from "../TopBar";
import Divider from '@mui/material/Divider';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import Chip from '@mui/material/Chip';

import {Global} from '@emotion/react';
import {styled} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import MarkerClusterGroup from 'react-leaflet-cluster'
import {MapContainer, Marker, Polyline, TileLayer, useMap, Tooltip, useMapEvents} from "react-leaflet";
import CardContent from "@mui/joy/CardContent";
import {Card, IconButton} from "@mui/material";
import Grid from "@mui/material/Grid";
import agent from "../../agent";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {getAppleMapsLinks, getGoogleMapsLink, getLatLon, isFreakOwner} from "../../utils/freakUtils";
import {sanitizeHtml} from '../../utils/sanitize';
import useTranslation from "../../customHooks/translations";
import FreakPopup from "./FreakPopup";
import ImageViewComponent from "../ImageView/ImageViewComponent";
import Button from "@mui/material/Button";
import EditIcon from '@mui/icons-material/Edit';
import {DEFAULT_THEME_COLOR} from "../../constants/theme";
import ButtonGroup from "@mui/material/ButtonGroup";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfirmationModal from "../ConfirmationModal";
import {DELETE_FREAK_PLACE, TOP_NAVIGATION_VISIBILITY} from "../../constants/actionTypes";
import SendIcon from '@mui/icons-material/Send';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import YouTubeIcon from "@mui/icons-material/YouTube";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LanguageIcon from '@mui/icons-material/Language';
import FreakListForPlace from "./FreakListForPlace";
import {useMediaQuery} from "react-responsive";
import SmallTopLoader from "../Loaders/SmallTopLoader";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import FreakLocalizationTracker from "./FreakLocalizationTracker";
import Box from "@mui/material/Box";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TerrainIcon from '@mui/icons-material/Terrain';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import WaterIcon from '@mui/icons-material/Water';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import IosShareIcon from '@mui/icons-material/IosShare';
import MuiTooltip from '@mui/material/Tooltip';
import {RESTRICTED_PLACES_VIEW_PATH} from "../../constants/restrictedViews";
import Avatar from "@mui/material/Avatar";
import PlacesSearchComponent from "../Search/PlacesSearchComponent";
import {ALGOLIA_INDEX_NAME_FREAK_PLACES} from "../../constants/commonConstants";
import {CHAT_ENABLED} from "../../constants/featureFlags";
import CommonLoader from "../Loaders/CommonLoader";
import DownloadGpxComponent from "../DownloadGpx/DownloadGpxComponent";
import PlaceBlastsComponent from '../Blasts/PlaceBlastsComponent';
import PredictionTodayCard from '../fishing/PredictionTodayCard';
import PredictionWeekStrip from '../fishing/PredictionWeekStrip';
import LogCatchDialog from '../fishing/LogCatchDialog';
import CatchLogSection from '../fishing/CatchLogSection';
import WeatherDayCard from '../weather/WeatherDayCard';
import WeatherWeekStrip from '../weather/WeatherWeekStrip';
import WeatherHourStrip from '../weather/WeatherHourStrip';
import MushroomRadarDialog from '../mushrooms/MushroomRadarDialog';
import FishingRadarDialog from '../fishing/FishingRadarDialog';

const StyledBox = styled('div')(({theme}) => ({
  // backgroundColor: 'white',
}));

const Puller = styled('div')(({theme}) => ({
  width: 30,
  height: 6,
  // backgroundColor: 'white',
  borderRadius: 3,
  position: 'absolute',
  top: 8,
  left: 'calc(50% - 15px)',
}));


const PullerMobile = styled(ExpandMoreIcon)(({theme}) => ({
  width: 30,
  height: 30,
  color: 'white',
  position: 'absolute',
  top: 60,
  left: 'calc(50% - 15px)',
  cursor: 'pointer',
}));

function RecenterAutomatically({position}) {
  const map = useMap();
  useEffect(() => {
    map.setView(position);
  }, [position, map]);

  return null;
}

const FreakPlaces = (props) => {
  const translation = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const freakPlaceMapSlug = location?.state?.freakPlaceMapSlug;
  const freakPlaceMap = location?.state?.freakPlaceMap;

  const device = props.device;
  const context = props.context;
  const isDesktop = useMediaQuery({minWidth: 992});

  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState([50.258598, 19.020420]);
  const [freakPlaces, setFreaksPlaces] = useState([]);
  const [filteredFreakPlaces, setFilteredFreakPlaces] = useState([]);
  const [selectedFreakPlace, setSelectedFreakPlace] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [confirmMethod, setConfirmMethod] = useState('');
  const [mapKey, setMapKey] = useState(0);
  const [showMap, setShowMap] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [isFreakPlaceExists, setIsFreakPlaceExists] = useState(false);
  const [shareTooltip, setShareTooltip] = useState(translation.freakPlaces.copyLink);
  const [isPlacesListExpanded, setIsPlacesListExpanded] = useState(false);
  const [mapZoom, setMapZoom] = useState(10);
  const [drawerPlaceLoading, setDrawerPlaceLoading] = useState(false);
  const [predictionTab, setPredictionTab] = useState('info');
  const [predictionData, setPredictionData] = useState(null);
  const [predictionLoading, setPredictionLoading] = useState(false);
  const [selectedPredictionDate, setSelectedPredictionDate] = useState(null);
  const [logCatchOpen, setLogCatchOpen] = useState(false);
  const [catchLogsData, setCatchLogsData] = useState(null);
  const [catchLogsLoading, setCatchLogsLoading] = useState(false);
  const [weatherData, setWeatherData] = useState(null);
  const [weatherLoading, setWeatherLoading] = useState(false);
  const [selectedWeatherDate, setSelectedWeatherDate] = useState(null);
  const [mushroomRadarOpen, setMushroomRadarOpen] = useState(false);
  const [fishingRadarOpen, setFishingRadarOpen] = useState(false);
  const [pendingFishingTab, setPendingFishingTab] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '' });

  // Auto-open the mushroom radar when deep-linked (e.g. from the About page news section)
  useEffect(() => {
    const params = new URLSearchParams(location?.search);
    if (params.get('mushroomRadar') === 'open') {
      setMushroomRadarOpen(true);
      params.delete('mushroomRadar');
      navigate(
        { pathname: location.pathname, search: params.toString() },
        { replace: true },
      );
    }
  }, [location?.search, location?.pathname, navigate]);

  // Auto-open the fishing radar when deep-linked
  useEffect(() => {
    const params = new URLSearchParams(location?.search);
    if (params.get('fishingRadar') === 'open') {
      setFishingRadarOpen(true);
      params.delete('fishingRadar');
      navigate(
        { pathname: location.pathname, search: params.toString() },
        { replace: true },
      );
    }
  }, [location?.search, location?.pathname, navigate]);

  // Capture a fishing feature deep-link (e.g. from the About page news section).
  // The place list may not be loaded yet, so remember the requested tab and open
  // the first place once the fishing places are available (see effect below).
  useEffect(() => {
    const params = new URLSearchParams(location?.search);
    const fishingTab = params.get('fishing');
    if (fishingTab && context === 'fishing') {
      setPendingFishingTab(fishingTab);
      params.delete('fishing');
      navigate(
        { pathname: location.pathname, search: params.toString() },
        { replace: true },
      );
    }
  }, [location?.search, location?.pathname, navigate, context]);

  const maxBoundsRef = useRef(null);
  const minZoomRef = useRef(null);
  const mapRef = useRef(null);
  const markerRefs = useRef({});
  const isSearchingRef = useRef(false);
  const prevIsSearchingRef = useRef(false);
  const mapZoolLabelThreshold = 11;
  const paddingLeft = (isDesktop && props.leftNavigationOpen) ? 300 : (isDesktop && !props.leftNavigationOpen ? 65 : 0);

  useEffect(() => {
    const setCurrentPosition = async () => {
      await getLatLon((position) => {
        setPosition([position.latitude, position.longitude]);
      }, () => {
      });
    };

    setCurrentPosition();
  }, []);

  useEffect(() => {
    if (!freakPlaceMapSlug || !freakPlaceMap) {
      return;
    }

    const interval = setInterval(() => {
      if (mapRef?.current) {
        mapRef.current.flyTo(
          [freakPlaceMap.coordinates.latitude, freakPlaceMap.coordinates.longitude],
          13,
          { duration: 1 }
        );
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, [freakPlaceMapSlug, freakPlaceMap]);

  const toMarker = freakPlace => {
    const lat = freakPlace?.map?.coordinates?.latitude;
    const lon = freakPlace?.map?.coordinates?.longitude;
    return {
      lat,
      lon,
      id: freakPlace.id,
      title: freakPlace.title,
      description: freakPlace.description,
      slug: freakPlace.slug,
      images: freakPlace.images,
      map: freakPlace.map,
      public: freakPlace.public,
      type: freakPlace.type,
    };
  };

  const fitMapToMarkers = markers => {
    const validMarkers = (markers || []).filter(marker => marker.lat && marker.lon);
    if (!validMarkers.length || !mapRef.current) {
      return;
    }

    if (validMarkers.length === 1) {
      mapRef.current.flyTo([validMarkers[0].lat, validMarkers[0].lon], 13, {duration: 1});
      return;
    }

    const bounds = L.latLngBounds(validMarkers.map(marker => [marker.lat, marker.lon]));
    mapRef.current.fitBounds(bounds, {padding: [50, 50], maxZoom: 13});
  };

  // Search all places server-side (ignores the current viewport bounds).
  const fetchSearchResults = async query => {
    setIsLoading(true);

    try {
      const response = await agent.FreaksPlaces.all(
        context,
        props.publicFreakPlaceFilter === undefined ? true : props.publicFreakPlaceFilter,
        props.privateFreakPlaceFilter === undefined ? true : props.privateFreakPlaceFilter,
        '',
        '',
        '',
        '',
        query,
      );
      const newMarkers = (response?.freaksPlaces || []).map(toMarker);

      setFreaksPlaces(newMarkers);
      setFilteredFreakPlaces(newMarkers);
      fitMapToMarkers(newMarkers);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchVisibleData = async bounds => {
    setIsLoading(true);

    const response = await agent.FreaksPlaces.all(
      context,
      props.publicFreakPlaceFilter === undefined ? true : props.publicFreakPlaceFilter,
      props.privateFreakPlaceFilter === undefined ? true : props.privateFreakPlaceFilter,
      bounds.southWestLat,
      bounds.southWestLon,
      bounds.northEastLat,
      bounds.northEastLon,
    );

    const newMarkers = response?.freaksPlaces?.map(toMarker);

    if (newMarkers) {
      setFreaksPlaces(prevState => {
        const allMarkers = [...prevState, ...newMarkers];

        const uniqueMarkers = Array.from(new Map(allMarkers.map(marker => [marker.id, marker])).values());

        return uniqueMarkers;
      });
      // @todo get rid of this duplicate
      setFilteredFreakPlaces(prevState => {
        const allMarkers = [...prevState, ...newMarkers];

        const uniqueMarkers = Array.from(new Map(allMarkers.map(marker => [marker.id, marker])).values());

        return uniqueMarkers;
      });
    }

    setIsLoading(false);
  };

  useEffect(() => {
    if (isSearchingRef.current) {
      return;
    }

    setFreaksPlaces([]);
    setIsLoading(false);

    const bounds = mapRef?.current?.getBounds();
    if (bounds) {
      const southwest = bounds.getSouthWest();
      const northeast = bounds.getNorthEast();

      const visibleBounds = {
        southWestLat: southwest.lat,
        southWestLon: southwest.lng,
        northEastLat: northeast.lat,
        northEastLon: northeast.lng,
      };

      fetchVisibleData(visibleBounds);
    }
  }, [props.context]);

  // Debounced server-side text search across all places (regardless of viewport).
  useEffect(() => {
    const query = (props.freakPlaceNameFilter || '').trim();
    isSearchingRef.current = Boolean(query);

    const handler = setTimeout(() => {
      if (query) {
        fetchSearchResults(query);
      } else if (prevIsSearchingRef.current) {
        // Search was just cleared — resume normal viewport loading.
        maxBoundsRef.current = null;
        minZoomRef.current = null;
        setFreaksPlaces([]);

        const bounds = mapRef?.current?.getBounds();
        if (bounds) {
          const southwest = bounds.getSouthWest();
          const northeast = bounds.getNorthEast();

          fetchVisibleData({
            southWestLat: southwest.lat,
            southWestLon: southwest.lng,
            northEastLat: northeast.lat,
            northEastLon: northeast.lng,
          });
        }
      }

      prevIsSearchingRef.current = Boolean(query);
    }, 400);

    return () => clearTimeout(handler);
  }, [props.freakPlaceNameFilter, context, props.publicFreakPlaceFilter, props.privateFreakPlaceFilter]);

  useEffect(() => {
    if (!isSearchingRef.current) {
      setFreaksPlaces([]);
      setIsLoading(false);
    }

    const handleMapMoveEnd = debounce(() => {
      if (isSearchingRef.current) {
        return;
      }

      const bounds = mapRef?.current?.getBounds();
      const zoom = mapRef?.current?.getZoom();

      if (bounds) {
        const southwest = bounds.getSouthWest();
        const northeast = bounds.getNorthEast();

        const visibleBounds = {
          southWestLat: southwest.lat,
          southWestLon: southwest.lng,
          northEastLat: northeast.lat,
          northEastLon: northeast.lng,
        };

        // Check if the new bounds exceed the max bounds
        const isExceedingMaxBounds = !maxBoundsRef.current || (
          visibleBounds.southWestLat < maxBoundsRef.current.southWestLat ||
          visibleBounds.southWestLon < maxBoundsRef.current.southWestLon ||
          visibleBounds.northEastLat > maxBoundsRef.current.northEastLat ||
          visibleBounds.northEastLon > maxBoundsRef.current.northEastLon
        );

        // Check if the zoom level has decreased
        const isZoomLowerThanLastMin = minZoomRef.current === null || zoom < minZoomRef.current;

        if (isExceedingMaxBounds || isZoomLowerThanLastMin) {
          fetchVisibleData(visibleBounds);
          maxBoundsRef.current = {
            southWestLat: visibleBounds.southWestLat,
            southWestLon: visibleBounds.southWestLon,
            northEastLat: visibleBounds.northEastLat,
            northEastLon: visibleBounds.northEastLon,
          };
        }

        if (!minZoomRef.current || zoom < minZoomRef.current) {
          minZoomRef.current = zoom;
        }
      }
    }, 300);

    mapRef?.current?.on('moveend', handleMapMoveEnd);

    handleMapMoveEnd();

    return () => {
      mapRef?.current?.off('moveend', handleMapMoveEnd);
    };
  }, [
    props.context,
    props.privateFreakPlaceFilter,
    props.publicFreakPlaceFilter,
    isModalOpen,
    mapRef.current,
  ]);

  const ZoomHandler = () => {
    useMapEvents({
      zoomend: () => {
        const currentZoom = mapRef.current.getZoom();
        setMapZoom(currentZoom);
      },
    });

    return null;
  };

  const handleOpenModal = (confirmMethod) => {
    setModalOpen(true);
    setConfirmMethod(confirmMethod);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleConfirm = (selectedFreakPlace) => {
    if (confirmMethod === 'delete') {
      props.onClickDelete(agent.FreaksPlaces.del(selectedFreakPlace.id));
    }
    reloadMap();
    handleCloseModal();
  };

  const reloadMap = () => {
    setMapKey(prevKey => prevKey + 1);
    setTimeout(() => setShowMap(true), 100);
  };

  const toggleDrawerList = newOpen => () => {
    setIsPlacesListExpanded(!newOpen);
  };

  const toggleDrawer = (newOpen, freakSlug) => async () => {
    setSelectedFreakPlace(null);
    setOpen(newOpen);
    setPredictionTab('info');
    setSelectedPredictionDate(null);
    setSelectedWeatherDate(null);
    setPredictionData(null);
    setCatchLogsData(null);
    setWeatherData(null);

    if (!newOpen || !freakSlug) return;

    setDrawerPlaceLoading(true);
    const response = await agent.FreaksPlaces.get(freakSlug, context, 'tablet');
    setSelectedFreakPlace(response.freakPlace);
    setDrawerPlaceLoading(false);

    if (response.freakPlace?.id) {
      const placeId = response.freakPlace.id;

      setWeatherLoading(true);
      agent.Weather.get(placeId)
        .then(data => setWeatherData(data))
        .catch(() => {})
        .finally(() => setWeatherLoading(false));

      if (context === 'fishing') {
        setPredictionLoading(true);
        setCatchLogsLoading(true);
        const [predResponse, catchResponse] = await Promise.allSettled([
          agent.FishingPrediction.get(placeId),
          agent.CatchLog.getForPlace(placeId),
        ]);
        if (predResponse.status === 'fulfilled') setPredictionData(predResponse.value);
        if (catchResponse.status === 'fulfilled') setCatchLogsData(catchResponse.value);
        setPredictionLoading(false);
        setCatchLogsLoading(false);
      }
    }
  };

  // Once fishing places have loaded, open the first one on the deep-linked tab.
  useEffect(() => {
    if (!pendingFishingTab || context !== 'fishing' || !freakPlaces?.length) return;
    const firstSlug = freakPlaces[0]?.slug;
    if (!firstSlug) return;
    const tab = pendingFishingTab;
    setPendingFishingTab(null);
    (async () => {
      await toggleDrawer(true, firstSlug)();
      setPredictionTab(tab);
    })();
    // Intentionally excludes toggleDrawer/setters from deps — this should only
    // re-run when the deep-link intent or the loaded places change.
  }, [pendingFishingTab, freakPlaces, context]);

  // Fallback: if a fishing feature was deep-linked but no place loads within the
  // grace period (e.g. there are no fishing places), show a toast instead. The
  // effect above clears pendingFishingTab as soon as a place opens, which cancels
  // this timer, so the toast only fires when nothing was opened.
  useEffect(() => {
    if (!pendingFishingTab || context !== 'fishing') return undefined;
    const timer = setTimeout(() => {
      setPendingFishingTab(null);
      setSnackbar({ open: true, message: translation.freakPlaces.noFishingPlaces });
    }, 6000);
    return () => clearTimeout(timer);
  }, [pendingFishingTab, context, translation]);

  const drawerBleeding = 0;
  const drawerBleedingMobile = 0; // @todo

  const publicIcon = new Icon({
    iconUrl: '/icons/marker-public-icon.png',
    iconSize: [25, 25],
    iconAnchor: [12, 41]
  });

  const privateIcon = new Icon({
    iconUrl: '/icons/marker-private-icon.png',
    iconSize: [25, 25],
    iconAnchor: [12, 41]
  });

  const myLocationIcon = new Icon({
    iconUrl: '/icons/location-pin.png',
    iconSize: [32, 32],
    iconAnchor: [16, 32]
  });

  const freakLocationIcon = new Icon({
    iconUrl: '/icons/pin.png',
    iconSize: [32, 32],
    iconAnchor: [16, 32]
  });

  // Function to handle when a card is clicked
  const handleCardClick = (place) => {
    const mappedPlace = {
      ...place,
      lat: place.lat || place.map?.coordinates?.latitude,
      lon: place.lon || place.map?.coordinates?.longitude
    };
    setSelectedFreakPlace(mappedPlace);

    // hide SwipeableDrawer
    setIsPlacesListExpanded(false);

    // Scroll to the marker and open the popup
    const marker = markerRefs.current[mappedPlace.id];
    if (marker) {
      mapRef.current.flyTo([mappedPlace.lat, mappedPlace.lon], 13, {duration: 1});
      marker.openPopup();
    } else {
      mapRef.current.flyTo([place.map?.coordinates?.latitude, place.map?.coordinates?.longitude], 13, {duration: 1});

      mapRef.current.once('moveend', () => {
        setTimeout(() => {
          if (markerRefs.current[mappedPlace.id]) {
            markerRefs.current[mappedPlace.id].openPopup();
          }
        }, 4000); // @todo think how to do this better
      });
    }
  };

  const buildPlaceShareUrl = (slug) => {
    const params = new URLSearchParams({place: slug});
    if (context) {
      params.set('context', context);
    }
    return `${window.location.origin}${RESTRICTED_PLACES_VIEW_PATH}?${params.toString()}`;
  };

  const handleSharePlace = async (place) => {
    const slug = place?.slug;
    if (!slug) {
      return;
    }

    const url = buildPlaceShareUrl(slug);

    if (navigator.share) {
      try {
        await navigator.share({
          title: place?.title,
          text: place?.title,
          url,
        });
      } catch (error) {
        // Share sheet dismissed or unavailable — nothing to do.
      }
      return;
    }

    try {
      await navigator.clipboard.writeText(url);
      setShareTooltip(translation.freakPlaces.copied);
      setTimeout(() => setShareTooltip(translation.freakPlaces.copyLink), 2000);
    } catch (err) {
      setShareTooltip(translation.freakPlaces.copyFailed);
      setTimeout(() => setShareTooltip(translation.freakPlaces.copyLink), 2000);
    }
  };

  const formatBody = (selectedFreakPlace) => selectedFreakPlace?.body?.replace(/\n/g, '<br />');

  const getMarkerIcon = freakPlace => {
    if (freakPlace?.images && freakPlace.images.length) {

      return L.divIcon({
        html: `<div class="circle-icon" style="background-image: url(${freakPlace.images[0].imageUrl});"></div>`,
        iconSize: [25, 25],
        iconAnchor: [12, 12],
        className: 'custom-div-icon'
      });
    } else if (freakPlace.public) {
      return publicIcon;
    } else {
      return privateIcon;
    }
  };

  return (
    <div style={{paddingLeft}}>
      <Box sx={{overflow: 'hidden'}}>
        <TopBar/>
        {context === 'mushroom' && (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 1, pt: 1 }}>
            <Button
              variant="outlined"
              size="small"
              onClick={() => setMushroomRadarOpen(true)}
              sx={{ ml: 1 }}
            >
              🍄 {translation.mushroomRadar.button}
            </Button>
          </Box>
        )}
        {context === 'fishing' && (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 1, pt: 1 }}>
            <Button
              variant="outlined"
              size="small"
              onClick={() => setFishingRadarOpen(true)}
              sx={{ ml: 1 }}
            >
              🎣 {translation.fishingRadar.button}
            </Button>
          </Box>
        )}
        {
          isDesktop
            ? <PlacesSearchComponent
              indexName={ALGOLIA_INDEX_NAME_FREAK_PLACES}
              context={context}
              handleCardClick={handleCardClick}
              mapRef={mapRef}
              overlay
            />
            : null
        }
        {
          isLoading
            ? <SmallTopLoader/>
            : null
        }
        {
          showMap ? (
            <Box sx={{
              overflow: 'hidden',
            }}>
              <MapContainer
                center={position}
                zoom={mapZoom}
                style={{
                  height: '100vh',
                  width: '100wh',
                }}
                ref={mapRef}
                attributionControl={false}
                key={mapKey}
                whenReady={() => {
                  setTimeout(() => {
                    mapRef.current?.invalidateSize();
                  }, 500);
                }}
              >
                <ZoomHandler/>
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <MarkerClusterGroup
                  chunkedLoading
                >
                  {freakPlaces?.map(freakPlace => (
                    <Marker
                      key={freakPlace?.slug}
                      position={[freakPlace.lat, freakPlace.lon]}
                      icon={getMarkerIcon(freakPlace)}
                      ref={(ref) => {
                        markerRefs.current[freakPlace.id] = ref;

                        if (freakPlace?.map?.slug === freakPlaceMapSlug && ref) {
                          setIsFreakPlaceExists(true);
                          setTimeout(() => {
                            ref.openPopup();
                          }, 500);
                        }
                      }}
                      eventHandlers={{
                        click: () => {
                          const loadRoute = async () => {
                            const response = await agent.FreaksPlaces.get(freakPlace.slug, context, 'tablet');
                            setSelectedFreakPlace({
                              ...response.freakPlace
                            });
                          };
                          loadRoute();
                        },
                      }}
                    >
                      {
                        mapZoom >= mapZoolLabelThreshold
                          ? <Tooltip direction="bottom" offset={[0, 0]} permanent>
                            {freakPlace?.title || "Label"}
                          </Tooltip>
                          : null
                      }

                      <FreakPopup
                        title={freakPlace?.title}
                        map={freakPlace?.map}
                        imageUrl={freakPlace?.images?.[0]?.imageUrl || freakPlace.imageUrl}
                        type={freakPlace?.type}
                        onClick={toggleDrawer(true, freakPlace?.slug)}
                      />
                    </Marker>
                  ))}
                  {
                    selectedFreakPlace?.route
                      ? <Polyline
                        pathOptions={{
                          color: DEFAULT_THEME_COLOR,
                          weight: 4,
                          opacity: 0.9,
                          lineJoin: 'round',
                          lineCap: 'round'
                        }}
                        positions={selectedFreakPlace?.route}
                      />
                      : null
                  }
                  {!isFreakPlaceExists && freakPlaceMap?.coordinates?.latitude && freakPlaceMap?.coordinates?.longitude ? (
                    <Marker position={[freakPlaceMap?.coordinates?.latitude, freakPlaceMap?.coordinates?.longitude]}
                            icon={freakLocationIcon}/>
                  ) : null}
                  {position ? <Marker position={position} icon={myLocationIcon}/> : null}
                  <RecenterAutomatically position={position}/>
                </MarkerClusterGroup>
              </MapContainer>
            </Box>
          ) : null
        }

        {!isDesktop ? (
          <>
            <IconButton
              sx={{
                position: 'fixed',
                bottom: 100,
                right: 20,
                zIndex: 1000,
                width: 50,
                height: 50,
                backgroundColor: DEFAULT_THEME_COLOR,
                color: 'white',
                '&:focus': {
                  outline: 'none'
                },
              }}
              onClick={toggleDrawerList(isPlacesListExpanded)}
            >
              <ExpandLessIcon/>
            </IconButton>
            <CssBaseline/>
            <Global/>
            <SwipeableDrawer
              anchor="bottom"
              open={isPlacesListExpanded}
              onClose={toggleDrawerList(false)}
              onOpen={toggleDrawerList(true)}
              swipeAreaWidth={drawerBleedingMobile}
              disableSwipeToOpen={false}
              ModalProps={{
                keepMounted: true,
              }}
            >
              <StyledBox
                sx={{
                  position: 'relative',
                  top: -drawerBleedingMobile,
                  visibility: 'visible',
                  right: 0,
                  left: 0,
                }}
              >
                <PullerMobile onClick={toggleDrawerList(isPlacesListExpanded)}/>
                <Box
                  sx={{
                    padding: 1,
                    marginTop: 10,
                    overflowY: 'auto',
                    height: '100vh',
                  }}
                >
                  <PlacesSearchComponent
                    indexName={ALGOLIA_INDEX_NAME_FREAK_PLACES}
                    context={context}
                    handleCardClick={handleCardClick}
                    loadOnStart={true}
                    mapRef={mapRef}
                  />
                </Box>
              </StyledBox>
            </SwipeableDrawer>
          </>
        ) : null}

        <CssBaseline/>
        <Global/>
        <SwipeableDrawer
          anchor="bottom"
          open={open}
          onClose={toggleDrawer(false)}
          onOpen={toggleDrawer(true)}
          swipeAreaWidth={drawerBleeding}
          disableSwipeToOpen={false}
          ModalProps={{
            keepMounted: true,
          }}
        >
          <StyledBox
            sx={{
              position: isDesktop ? 'relative' : 'absolute',
              top: -drawerBleeding,
              visibility: 'visible',
              right: 0,
              left: 0,
            }}
          >
            <Puller/>
            <Card sx={{
              height: isDesktop ? '100vh' : '90vh',
              boxShadow: 'none',
              overflow: 'auto',
            }}>
              {
                drawerPlaceLoading
                  ? <CommonLoader/>
                  : <>
                    <Box sx={isDesktop ? {
                      maxWidth: 680,
                      width: '100%',
                      mx: 'auto',
                      px: 2,
                      pt: 2,
                      '& .image-gallery, & .image-gallery-content, & .image-gallery-slide-wrapper': {
                        borderRadius: '16px',
                      },
                    } : undefined}>
                    {selectedFreakPlace?.images?.length ? (
                      <ImageViewComponent
                        images={selectedFreakPlace.images}
                        showThumbnails={false}
                        useOriginalHeight={true}
                        desktopHeight={isDesktop ? 380 : undefined}
                        fullScreenButton={'hide'}
                      />
                    ) : (
                      <Box sx={{
                        height: isDesktop ? 300 : 220,
                        borderRadius: isDesktop ? '16px' : 0,
                        background: 'linear-gradient(135deg, #0d1b2a 0%, #0a2a1c 50%, #0d3d2e 100%)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderBottom: '1px solid rgba(255,255,255,0.07)',
                      }}>
                        <TerrainIcon sx={{
                          fontSize: 80,
                          color: 'rgba(54,201,162,0.18)',
                          mb: 1.5,
                          filter: 'drop-shadow(0 0 18px rgba(54,201,162,0.15))',
                        }} />
                        <Typography sx={{
                          color: 'rgba(255,255,255,0.3)',
                          fontSize: 13,
                          fontWeight: 500,
                          letterSpacing: '0.06em',
                          textTransform: 'uppercase',
                        }}>
                          No photo available
                        </Typography>
                      </Box>
                    )}
                    </Box>
                    <Box sx={{ display: 'flex', borderBottom: '1px solid #e0e0e0' }}>
                      {(context === 'fishing'
                        ? [
                            { id: 'info', label: translation.freakPlacesTabs.info },
                            { id: 'prediction', label: translation.freakPlacesTabs.prediction },
                            { id: 'catches', label: translation.freakPlacesTabs.catches },
                            { id: 'weather', label: translation.freakPlacesTabs.weather },
                          ]
                        : [
                            { id: 'info', label: translation.freakPlacesTabs.info },
                            { id: 'weather', label: translation.freakPlacesTabs.weather },
                          ]
                      ).map(tab => (
                        <Button
                          key={tab.id}
                          onClick={() => setPredictionTab(tab.id)}
                          sx={{
                            flex: 1,
                            borderRadius: 0,
                            borderBottom: predictionTab === tab.id ? `2px solid ${DEFAULT_THEME_COLOR}` : '2px solid transparent',
                            color: predictionTab === tab.id ? DEFAULT_THEME_COLOR : 'text.secondary',
                            fontWeight: predictionTab === tab.id ? 'bold' : 'normal',
                            py: 1.5,
                            fontSize: 12,
                            '&:focus': { outline: 'none' },
                          }}
                        >
                          {tab.label}
                        </Button>
                      ))}
                    </Box>
                    <CardContent>
                      {(predictionTab === 'catches' && context === 'fishing') ? (
                        <Box sx={{ p: 1 }}>
                          <CatchLogSection
                            catches={catchLogsData}
                            isLoading={catchLogsLoading}
                            placeLat={selectedFreakPlace?.map?.coordinates?.latitude}
                            placeLon={selectedFreakPlace?.map?.coordinates?.longitude}
                            onRefresh={() => {
                              if (selectedFreakPlace?.id) {
                                agent.CatchLog.getForPlace(selectedFreakPlace.id)
                                  .then(data => setCatchLogsData(data))
                                  .catch(() => {});
                              }
                            }}
                          />
                          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                            <Button
                              variant="contained"
                              sx={{ bgcolor: DEFAULT_THEME_COLOR, '&:hover': { bgcolor: '#2aad8a' } }}
                              onClick={() => setLogCatchOpen(true)}
                            >
                              {translation.fishingPrediction.saveNewCatch}
                            </Button>
                          </Box>
                          {selectedFreakPlace?.id && (
                            <LogCatchDialog
                              open={logCatchOpen}
                              onClose={(success) => {
                                setLogCatchOpen(false);
                                if (success && selectedFreakPlace?.id) {
                                  agent.CatchLog.getForPlace(selectedFreakPlace.id)
                                    .then(data => setCatchLogsData(data))
                                    .catch(() => {});
                                }
                              }}
                              freakPlaceId={selectedFreakPlace.id}
                            />
                          )}
                        </Box>
                      ) : (predictionTab === 'prediction' && context === 'fishing') ? (
                        <Box sx={{ p: 1 }}>
                          <PredictionTodayCard
                            day={
                              selectedPredictionDate
                                ? predictionData?.predictions?.find(p => p.date === selectedPredictionDate)
                                : predictionData?.predictions?.[0]
                            }
                            isLoading={predictionLoading}
                          />
                          <Divider sx={{ my: 2 }} />
                          <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
                            {translation.fishingPrediction.weekForecast}
                          </Typography>
                          <PredictionWeekStrip
                            predictions={predictionData?.predictions ?? []}
                            onSelectDay={day => setSelectedPredictionDate(day.date)}
                            selectedDate={selectedPredictionDate ?? predictionData?.predictions?.[0]?.date}
                          />
                          {predictionData?.fallback && (
                            <Alert severity="info" sx={{ mt: 1, fontSize: 12 }}>
                              {translation.fishingPrediction.fallbackNotice}
                            </Alert>
                          )}
                          {selectedFreakPlace?.possibleFish?.length > 0 && (
                            <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center' }}>
                              <Typography variant="caption" sx={{ width: '100%', color: 'text.secondary', fontWeight: 600 }}>
                                {translation.fishingPrediction.possibleFish}
                              </Typography>
                              {selectedFreakPlace.possibleFish.map(f => (
                                <Chip key={f} label={f} size="small" variant="outlined" />
                              ))}
                            </Box>
                          )}
                          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                            <Button
                              variant="contained"
                              sx={{ bgcolor: DEFAULT_THEME_COLOR, '&:hover': { bgcolor: '#2aad8a' } }}
                              onClick={() => setLogCatchOpen(true)}
                            >
                              {translation.fishingPrediction.saveCatch}
                            </Button>
                          </Box>
                          {selectedFreakPlace?.id && (
                            <LogCatchDialog
                              open={logCatchOpen}
                              onClose={() => setLogCatchOpen(false)}
                              freakPlaceId={selectedFreakPlace.id}
                            />
                          )}
                        </Box>
                      ) : predictionTab === 'weather' ? (
                        <Box sx={{ p: 1 }}>
                          <WeatherDayCard
                            day={
                              selectedWeatherDate
                                ? weatherData?.days?.find(d => d.date === selectedWeatherDate)
                                : weatherData?.days?.[0]
                            }
                            isLoading={weatherLoading}
                          />
                          <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
                            {translation.weather.weekForecast}
                          </Typography>
                          <WeatherWeekStrip
                            days={weatherData?.days ?? []}
                            selectedDate={selectedWeatherDate ?? weatherData?.days?.[0]?.date}
                            onSelectDay={day => setSelectedWeatherDate(day.date)}
                          />
                          {(!selectedWeatherDate || selectedWeatherDate === weatherData?.days?.[0]?.date) &&
                            weatherData?.days?.[0]?.hours && (
                            <>
                              <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 2, mb: 1 }}>
                                {translation.weather.hourlyForecast}
                              </Typography>
                              <WeatherHourStrip hours={weatherData.days[0].hours} />
                            </>
                          )}
                        </Box>
                      ) : (<>
                      <Grid container>
                        <Grid item xs={12} sx={{
                          marginLeft: 0.5,
                          fontWeight: 700,
                          marginTop: 5,
                          display: 'flex',
                          justifyContent: 'center'
                        }}
                        >
                          <Typography variant="h5" fontWeight="bold" gutterBottom align="center">
                            {selectedFreakPlace?.title}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sx={{
                          margin: 3
                        }}>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{
                              marginLeft: 1,
                              fontWeight: 'bold',
                              marginTop: 0.35,
                              display: 'flex',
                              // marginBottom: 5,
                              justifyContent: 'center',
                            }}
                            dangerouslySetInnerHTML={{__html: sanitizeHtml(formatBody(selectedFreakPlace))}}
                          />
                        </Grid>
                        {
                          selectedFreakPlace?.route && selectedFreakPlace?.route?.length
                            ? <Grid item xs={12}>
                              <FreakLocalizationTracker
                                routeCoordinates={selectedFreakPlace?.route}
                                position={position}
                                isRunning={false}
                                zoom={7}
                              />
                            </Grid>
                            : null
                        }
                        <Grid item xs={12}>
                          <Box mt={2} textAlign="center">
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{
                                marginLeft: 1,
                                display: 'flex',
                                marginTop: 5,
                                justifyContent: 'center',
                              }}
                            >
                              {selectedFreakPlace?.map?.description}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <Typography
                              variant="body2"
                              color="text.primary"
                              sx={{
                                marginLeft: 1,
                                fontWeight: 'bold',
                                marginTop: 0.75,
                                fontSize: 13,
                                display: 'flex',
                                justifyContent: 'center'
                              }}
                            >
                              <MuiTooltip title={shareTooltip}>
                                <IconButton
                                  sx={{
                                    marginTop: -1,
                                    '&:focus': {
                                      outline: 'none'
                                    },
                                    '&:hover': {
                                      color: DEFAULT_THEME_COLOR,
                                      borderColor: DEFAULT_THEME_COLOR,
                                    },
                                  }}
                                  onClick={() => handleSharePlace(selectedFreakPlace)}
                                  aria-label={translation.freakPlaces.sharePlace}
                                >
                                  <IosShareIcon sx={{color: DEFAULT_THEME_COLOR, width: 45, height: 45}}/>
                                </IconButton>
                              </MuiTooltip>
                              <IconButton
                                sx={{
                                  marginTop: -1,
                                  '&:focus': {
                                    outline: 'none'
                                  },
                                  '&:hover': {
                                    color: DEFAULT_THEME_COLOR,
                                    borderColor: DEFAULT_THEME_COLOR,
                                  },
                                }}
                                component={Link}
                                target="_blank"
                                rel="noopener"
                                to={getGoogleMapsLink(selectedFreakPlace?.map?.coordinates?.latitude, selectedFreakPlace?.map?.coordinates?.longitude)}
                                aria-label="Navigate"
                              >
                                <Avatar
                                  sx={{
                                    width: 45,
                                    height: 45,
                                    borderRadius: 0,
                                    marginTop: 1,
                                  }}
                                  src={'./../icons/google-maps-icon.png'}
                                />
                              </IconButton>
                              <IconButton
                                sx={{
                                  marginTop: -1,
                                  '&:focus': {
                                    outline: 'none'
                                  },
                                  '&:hover': {
                                    color: DEFAULT_THEME_COLOR,
                                    borderColor: DEFAULT_THEME_COLOR,
                                  },
                                }}
                                component={Link}
                                target="_blank"
                                rel="noopener"
                                to={getAppleMapsLinks(selectedFreakPlace?.map?.coordinates?.latitude, selectedFreakPlace?.map?.coordinates?.longitude)}
                                aria-label="Navigate"
                              >
                                <Avatar
                                  sx={{
                                    width: 45,
                                    height: 45,
                                    borderRadius: 0,
                                    marginTop: 1,
                                  }}
                                  src={'./../icons/apple-maps-icon.png'}
                                />
                              </IconButton>

                              {
                                selectedFreakPlace?.placeSiteUrl
                                  ? <IconButton
                                    component={Link}
                                    target="_blank"
                                    rel="noopener"
                                    to={selectedFreakPlace.placeSiteUrl}
                                    aria-label="Site"
                                    sx={{
                                      '&:focus': {
                                        outline: 'none'
                                      },
                                      '&:hover': {
                                        color: DEFAULT_THEME_COLOR,
                                        borderColor: DEFAULT_THEME_COLOR,
                                      },
                                    }}
                                  >
                                    <LanguageIcon sx={{color: DEFAULT_THEME_COLOR, width: 45, height: 45}}/>
                                  </IconButton>
                                  : null
                              }

                              {
                                selectedFreakPlace?.placeYoutubeUrl
                                  ? <IconButton
                                    component={Link}
                                    target="_blank"
                                    rel="noopener"
                                    to={selectedFreakPlace.placeYoutubeUrl}
                                    aria-label="Site"
                                    sx={{
                                      '&:focus': {
                                        outline: 'none'
                                      },
                                      '&:hover': {
                                        color: DEFAULT_THEME_COLOR,
                                        borderColor: DEFAULT_THEME_COLOR,
                                      },
                                    }}
                                  >
                                    <YouTubeIcon sx={{color: '#FF0000', width: 45, height: 45}}/>
                                  </IconButton>
                                  : null
                              }
                              {
                                selectedFreakPlace?.placeFacebookUrl
                                  ? <IconButton
                                    component={Link}
                                    target="_blank"
                                    rel="noopener"
                                    to={selectedFreakPlace.placeFacebookUrl}
                                    aria-label="Site"
                                    sx={{
                                      '&:focus': {
                                        outline: 'none'
                                      },
                                      '&:hover': {
                                        color: DEFAULT_THEME_COLOR,
                                        borderColor: DEFAULT_THEME_COLOR,
                                      },
                                    }}
                                  >
                                    <FacebookIcon sx={{color: '#1877F2', width: 45, height: 45}}/>
                                  </IconButton>
                                  : null
                              }
                              {
                                selectedFreakPlace?.placeInstagramUrl
                                  ? <IconButton
                                    component={Link}
                                    target="_blank"
                                    rel="noopener"
                                    to={selectedFreakPlace.placeInstagramUrl}
                                    aria-label="Site"
                                    sx={{
                                      '&:focus': {
                                        outline: 'none'
                                      },
                                      '&:hover': {
                                        color: DEFAULT_THEME_COLOR,
                                        borderColor: DEFAULT_THEME_COLOR,
                                      },
                                    }}
                                  >
                                    <InstagramIcon sx={{color: 'rgb(30, 48, 80)', width: 45, height: 45}}/>
                                  </IconButton>
                                  : null
                              }
                              {
                                selectedFreakPlace?.otherLinks?.map((link, index) => (
                                  <MuiTooltip key={`${link.name}-${index}`} title={link.name} arrow>
                                    <IconButton
                                      sx={{
                                        marginTop: -1,
                                        '&:focus': { outline: 'none' },
                                        '&:hover': { color: DEFAULT_THEME_COLOR },
                                      }}
                                      onClick={() => {
                                        if (window.cordova && window.cordova.InAppBrowser) {
                                          window.cordova.InAppBrowser.open(link.url, '_system');
                                        } else {
                                          window.open(link.url, '_blank');
                                        }
                                      }}
                                      aria-label={link.name}
                                    >
                                      {link.name === 'Kup zezwolenie'
                                        ? <ConfirmationNumberIcon sx={{ color: DEFAULT_THEME_COLOR, width: 45, height: 45 }} />
                                        : <OpenInNewIcon sx={{ color: DEFAULT_THEME_COLOR, width: 45, height: 45 }} />
                                      }
                                    </IconButton>
                                  </MuiTooltip>
                                ))
                              }
                              {
                                context === 'fishing'
                                  ? <MuiTooltip title="Check lake" arrow>
                                    <IconButton
                                      sx={{
                                        marginTop: -1,
                                        '&:focus': { outline: 'none' },
                                        '&:hover': { color: '#0288d1' },
                                      }}
                                      component={Link}
                                      target="_blank"
                                      rel="noopener"
                                      to={'https://www.genesismaps.com/Dashboard/SocialMap'}
                                      aria-label="Check lake"
                                    >
                                      <WaterIcon sx={{ color: '#0288d1', width: 45, height: 45 }} />
                                    </IconButton>
                                  </MuiTooltip>
                                  : null
                              }
                              {
                                selectedFreakPlace?.route && selectedFreakPlace?.route?.length
                                  ? <DownloadGpxComponent gpx={selectedFreakPlace?.route} fileName={selectedFreakPlace?.slug} />
                                  : null
                              }
                            </Typography>
                          </Grid>
                        </Grid>
                        {
                          selectedFreakPlace && selectedFreakPlace.author && isFreakOwner(props.currentUser.username, selectedFreakPlace) && !selectedFreakPlace.public
                            ?
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                width: '100%',
                                marginBottom: '16px',
                              }}
                            >
                              <ButtonGroup
                                sx={{
                                  display: 'flex',
                                  width: '100%',
                                  maxWidth: 520,
                                  gap: 1,
                                  justifyContent: 'center', // Center-align the buttons
                                  flexDirection: 'row',
                                }}
                                orientation="horizontal"
                                aria-label="vertical outlined button group"
                              >
                                <Button
                                  variant="outlined"
                                  style={{
                                    color: DEFAULT_THEME_COLOR,
                                    borderColor: DEFAULT_THEME_COLOR,
                                    'z-index': '0',
                                    borderRadius: 4,
                                    outline: 'none',
                                    marginLeft: 10,
                                    flex: 1,
                                  }}
                                  startIcon={<EditIcon/>}
                                  onClick={() => navigate(`/places-editor/${selectedFreakPlace.slug}`)}
                                >
                                  {translation.freakPlaces.edit}
                                </Button>

                                <Button
                                  variant="outlined"
                                  style={{
                                    color: DEFAULT_THEME_COLOR,
                                    borderColor: DEFAULT_THEME_COLOR,
                                    'z-index': '0',
                                    borderRadius: 4,
                                    outline: 'none',
                                    marginLeft: 10,
                                    marginRight: 10,
                                    flex: 1,
                                  }}
                                  startIcon={<DeleteIcon/>}
                                  onClick={() => handleOpenModal('delete', selectedFreakPlace)}
                                >
                                  {translation.freakPlaces.delete}
                                </Button>
                              </ButtonGroup>
                            </div>

                            : null
                        }
                      </Grid>
                      {
                        selectedFreakPlace?.status === 'waiting_for_approval'
                          ? <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              width: '100%',
                              marginBottom: '16px',
                            }}
                          >
                            <Button
                              variant="outlined"
                              disabled
                              style={{
                                color: DEFAULT_THEME_COLOR,
                                borderColor: DEFAULT_THEME_COLOR,
                                'z-index': '0',
                                borderRadius: 4,
                                margin: 10,
                                outline: 'none',
                                '&:focus': {
                                  outline: 'none'
                                },
                                '&:hover': {
                                  color: DEFAULT_THEME_COLOR,
                                  borderColor: DEFAULT_THEME_COLOR,
                                },
                                maxWidth: 500,
                              }}
                              startIcon={<HourglassBottomIcon/>}
                            >
                              {translation.freakPlaces.waitingForApproval}
                            </Button>
                          </div>
                          : null
                      }
                      {
                        !selectedFreakPlace?.public && selectedFreakPlace?.status !== 'waiting_for_approval'
                          ? <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              width: '100%',
                              marginBottom: '16px',
                            }}
                          >
                            <Button
                              variant="outlined"
                              style={{
                                color: DEFAULT_THEME_COLOR,
                                borderColor: DEFAULT_THEME_COLOR,
                                'z-index': '0',
                                borderRadius: 4,
                                margin: 10,
                                outline: 'none',
                                '&:focus': {
                                  outline: 'none'
                                },
                                '&:hover': {
                                  color: DEFAULT_THEME_COLOR,
                                  borderColor: DEFAULT_THEME_COLOR,
                                },
                                maxWidth: 500,
                              }}
                              startIcon={<SendIcon/>}
                              onClick={() => {
                                agent.FreaksPlaces.sendForPublic(selectedFreakPlace.slug);
                                setOpen(false);
                              }}
                            >
                              {translation.freakPlaces.sendForPublic}
                            </Button>
                          </div>
                          : null
                      }
                      {
                        CHAT_ENABLED && selectedFreakPlace?.chatId
                          ? <div
                            style={{
                              display: 'flex',
                              justifyContent: 'left',
                              width: '100%',
                              marginBottom: '16px',
                            }}
                          >
                            <Button
                              variant="outlined"
                              style={{
                                color: DEFAULT_THEME_COLOR,
                                borderColor: DEFAULT_THEME_COLOR,
                                'z-index': '0',
                                borderRadius: 4,
                                margin: 10,
                                outline: 'none',
                                '&:focus': {
                                  outline: 'none'
                                },
                                '&:hover': {
                                  color: DEFAULT_THEME_COLOR,
                                  borderColor: DEFAULT_THEME_COLOR,
                                },
                                maxWidth: 500,
                              }}
                              startIcon={<MailOutlineIcon/>}
                              onClick={() => {
                                navigate('/messages', {
                                  state: {
                                    selectedGroupId: selectedFreakPlace?.chatId,
                                  }
                                })
                              }}
                            >
                              Chat
                            </Button>
                          </div>
                          : null
                      }
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          width: '100%',
                          marginBottom: '16px',
                        }}
                      >
                        <Button
                          variant="contained"
                          style={{
                            backgroundColor: DEFAULT_THEME_COLOR,
                            color: 'white',
                            borderColor: DEFAULT_THEME_COLOR,
                            'z-index': '0',
                            borderRadius: 4,
                            margin: 10,
                            maxWidth: 500,
                          }}
                          onClick={() => setOpen(false)}
                        >
                          {translation.contextSwipeableDrawerComponent.close}
                        </Button>
                      </div>
                      <Divider/>

                      {
                        selectedFreakPlace?.map?.Freak?.length
                          ? <div className="container">
                            <div className="row">
                              <Grid item xs={12} sx={{
                                marginLeft: 1,
                                marginTop: 2,
                                fontWeight: '700',
                              }}>
                                <Typography gutterBottom variant="h7" component="div">
                                  {translation.freakPlaces.freaksFromThisPlace}
                                </Typography>
                              </Grid>
                              <div className="col-xs-12 col-md-10 offset-md-1">
                                <FreakListForPlace
                                  freaks={selectedFreakPlace?.map?.Freak}
                                />
                              </div>
                            </div>
                          </div>
                          : <Grid item xs={12} sx={{
                            marginTop: 2,
                          }}
                          >
                            <Typography variant="h5" fontWeight="bold" gutterBottom align="center">
                              {translation.freakPlaces.noFreaksFromThisPlace}
                            </Typography>
                          </Grid>
                      }

                      {selectedFreakPlace?.id && (
                        <PlaceBlastsComponent
                          freakPlaceId={selectedFreakPlace.id}
                          currentUser={props.currentUser}
                          canModify={!!props.currentUser}
                        />
                      )}
                      </>)}
                    </CardContent></>
              }
            </Card>
          </StyledBox>
          <ConfirmationModal
            isOpen={isModalOpen} onClose={handleCloseModal}
            onConfirm={() => handleConfirm(selectedFreakPlace)}/>
        </SwipeableDrawer>
        <MushroomRadarDialog open={mushroomRadarOpen} onClose={() => { setMushroomRadarOpen(false); navigate('/login'); }} />
        <FishingRadarDialog open={fishingRadarOpen} onClose={() => { setFishingRadarOpen(false); navigate('/login'); }} />
        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
        >
          <Alert
            onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
            severity="info"
            variant="filled"
            sx={{ width: '100%' }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  )
};

const mapStateToProps = state => ({
  currentUser: state.common.currentUser,
  device: state.common.device,
  publicFreakPlaceFilter: state.common.publicFreakPlaceFilter,
  privateFreakPlaceFilter: state.common.privateFreakPlaceFilter,
  freakPlaceNameFilter: state.common.freakPlaceNameFilter,
  leftNavigationOpen: state.common.leftNavigationOpen,
});

const mapDispatchToProps = dispatch => ({
  onClickDelete: payload =>
    dispatch({type: DELETE_FREAK_PLACE, payload}),
  setTopNavigationVisible: isVisible => dispatch({
    type: TOP_NAVIGATION_VISIBILITY,
    payload: isVisible
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(FreakPlaces);
